import { Component } from '@angular/core';

@Component({
  selector: 'dbs-footer',
  styleUrls: ['./footer.component.scss'],
  template: ``,
})
export class FooterComponent {
}
